export const CONNECTED_APP_INIT = 'INIT';
export const CONNECTED_APP_PENDING = 'PENDING';
export const CONNECTED_APP_ACTIVE = 'ACTIVE';
export const CONNECTED_APP_REVOKED = 'REVOKED';
export const CONNECTED_APP_FAILED = 'FAILED';
export const CONNECTED_APP_EXPIRED = 'EXPIRED';
